import { render, staticRenderFns } from "./spiderPage.vue?vue&type=template&id=19e2c64a&scoped=true"
import script from "./spiderPage.vue?vue&type=script&lang=js"
export * from "./spiderPage.vue?vue&type=script&lang=js"
import style0 from "./spiderPage.vue?vue&type=style&index=0&id=19e2c64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e2c64a",
  null
  
)

export default component.exports